import React, {useState, useEffect} from 'react';
import Time from '../Time';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
import AlertWindow from '../Alert';

class NotificationSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timerefresh:1,
      alertWindow:""
    }
    this.handleFormChange = this.handleFormChange.bind(this);
    this.saveSettings = this.saveSettings.bind(this);
    this.closeAlertWindow = this.closeAlertWindow.bind(this);
  }

  componentDidMount(){
  }

  //Gets the changes of your form and send it to the state
  handleFormChange = (e) =>{
    this.setState({[e.target.id]: e.target.value});
  }

  saveSettings = (e) =>{
    e.preventDefault();
    this.setState({alertWindow:"Settings Saved"});
  }

  closeAlertWindow = () =>{
    this.setState({alertWindow:""});
    this.props.close();
  }
  

  render() {

    let alertWindowHTML;
    if(this.state.alertWindow != ""){
      alertWindowHTML = <AlertWindow close={this.closeAlertWindow} title="Success" message={this.state.alertWindow}/>
    }

    return(
      <div>
        {alertWindowHTML}
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window">
            <div className="row">
                <div className="col-12 container p-4">
                  <h3>Notification Settings</h3>
                  <form onSubmit={this.saveSettings}>
                    <div className="mb-3">
                      <label for="timerefresh" className="form-label">Notification refresh Time:</label>
                      <input onChange={this.handleFormChange} type="range" className="form-range" min="1" max="15" step="1" defaultValue={1} id="timerefresh"></input>
                      <p>{this.state.timerefresh} min</p>
                    </div>
                    <button type="submit">Save Settings</button>
                  </form>
                </div>
            </div>
        </div>
      </div>
    )
  }
}

export default NotificationSettings;